(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gz-header"]) return;
  try {
    
  document.addEventListener('click',event=>{const link=event.target.closest('.gz-mobile-menu nav a');if(link)link.closest('details').removeAttribute('open')});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){const menu=document.querySelector('.gz-mobile-menu[open]');if(menu){menu.removeAttribute('open');menu.querySelector('summary').focus()}}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gz-stack"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',event=>{const button=event.target.closest('[data-gallery-src]');if(!button)return;const scope=button.closest('.gz-stack-media');const image=scope.querySelector('.gz-gallery-main');image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=button.dataset.gallerySrc;image.alt=button.dataset.galleryAlt;scope.querySelectorAll('[data-gallery-src]').forEach(item=>item.setAttribute('aria-pressed',String(item===button))) });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
